import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { Button, Form, Input, message, Modal, Space, Table, Upload } from "antd"
import { useForm } from "antd/lib/form/Form"
import { PlusOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../../tool/axios"
import { apiPrefix } from '../../../js/config'
import { CheckImgs } from "../../../component/common/Imgs"

const { Column } = Table

interface Prop {
    onChange?: () => void
}

export default function (prop: Prop) {

    const [form] = useForm()
    const [current, setCurrent] = useState<number>(0)
    const [urls, setUrls] = useState<string[]>([])
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    const param: { id: string } = useParams()
    const [data1, setData1] = useState<any[]>([])
    const [data2, setData2] = useState<any[]>([])

    const [visible, setVisible] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [fileList, setFileList] = useState<any[]>([])
    const [activeID, setActiveID] = useState<string>('')

    useEffect(() => {
        if (current === 0) {
            axiosTable('/keeper/check_in/detail/other_pay_records_in', {
                params: {
                    check_in_id: param.id
                }
            }).then((res: any) => {
                setData1(res)
            })

        } else {
            axiosTable('/keeper/check_in/detail/other_pay_records_out', {
                params: {
                    check_in_id: param.id
                }
            }).then((res: any) => {
                setData2(res)
            })
        }
    }, [current])

    const formItemLayout = {
        labelCol: { span: 5 },
        wrapperCol: { span: 8 }
    }

    const onFinish = () => {
        baseAxiosComplete.post('/keeper/check_in/detail/submit_refund', {
            pay_id: activeID,
            refund_amount: form.getFieldValue('refund_amount'),
            refund_reason: form.getFieldValue('refund_reason'),
            refund_prov_pic_list: form.getFieldValue('refund_prov_pic_list').map((el: any) => el.response.data[0]),
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()

                axiosTable('/keeper/check_in/detail/other_pay_records_in', {
                    params: {
                        check_in_id: param.id
                    }
                }).then((res: any) => {
                    setData1(res)
                })
            }
        })
    }

    const uploadFile = (e: { file: any, fileList: [] }) => {
        if (Array.isArray(e)) {
            return e
        }

        if (e.file.size < 300000) {
            return e && e.fileList

        } else {
            let r = e.fileList.every((el: any) => {
                return el.size < 300000
            })

            if (r) {
                return e.fileList
            }
        }
    }

    const handleChange = ({ fileList }: { fileList: any }) => {
        setFileList(fileList)

        form.setFieldsValue({
            item_pic_url: fileList
        })
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )

    return <div>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 其他收入 */}
        <div>
            <span style={{ fontSize: 16, marginRight: 20, marginBottom: 20, cursor: 'pointer', display: 'inline-block' }} className={current === 0 ? 'current' : ''} onClick={() => { setCurrent(0) }}>收款</span>
            <span style={{ fontSize: 16, marginRight: 20, marginBottom: 20, cursor: 'pointer', display: 'inline-block' }} className={current === 1 ? 'current' : ''} onClick={() => { setCurrent(1) }}>退款</span>
        </div>

        {current === 0 && <div>
            <Table pagination={false} scroll={{ x: 'max-content' }} style={{ width: '95%' }} dataSource={data1}>
                {/* pay_id */}
                <Column title="付款日期" dataIndex="pay_date" />
                <Column title="付款商品" dataIndex="other_item_name" />
                <Column title="付款方式" dataIndex="pay_way_desc" />
                <Column title="付款金额" dataIndex="pay_amount" />
                <Column title="付款凭证" dataIndex="pay_prov_pic_list" key="pay_prov_pic_list" render={(v: any) => {
                    return <Button onClick={() => {
                        setUrls(v.split(','))
                        setSiperVisible(true)
                    }} size="small" >查看</Button>
                }} />

                <Column title="备注" dataIndex="remark" />
                <Column title="录入人" dataIndex="create_user_name" />
                <Column title="审核结果" dataIndex="review_status" render={(v: number) => {
                    if (v === 0) return '待审核'
                    if (v === 1) return '审核通过'
                    if (v === 2) return '审核不通过'
                }} />

                <Column title="操作" render={(v: any) => {
                    if (v.review_status === 1) {
                        return <Button size="small" onClick={() => {
                            setActiveID(v.pay_id)
                            setVisible(true)
                        }}>申请退款</Button>

                    } else {
                        return ''
                    }
                }} />
            </Table>
        </div>}

        {current === 1 && <div>
            <Table pagination={false} scroll={{ x: 'max-content' }} style={{ width: '95%' }} dataSource={data2}>
                {/* refund_id */}
                <Column title="退款日期" dataIndex="refund_date" />
                <Column title="退款金额" dataIndex="refund_amount" />
                <Column title="录入人" dataIndex="create_user_name" />

                <Column title="审核结果" dataIndex="review_status" render={(v: number) => {
                    if (v === 0) return '待审核'
                    if (v === 1) return '审核通过'
                    if (v === 2) return '审核不通过'
                }} />
                <Column title="不通过原因" dataIndex="review_refuse_reason" />
            </Table>
        </div>}

        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />

        {/* 退款弹窗 */}
        <Modal title="申请退款" visible={visible} onOk={onFinish} onCancel={() => { setVisible(false) }}>
            <div>
                <Form style={{ marginTop: 40 }} form={form} name="validate_editor" {...formItemLayout}>
                    <Form.Item label="退款金额" name="refund_amount" rules={[{ required: true, message: '必须填写退款金额，纯数字' }]}  >
                        <Input />
                    </Form.Item>

                    <Form.Item label="退款原因" name="refund_reason" rules={[{ required: true, message: '必须填写退款原因' }]}  >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="上传图片"
                        valuePropName="fileList"
                        getValueFromEvent={uploadFile}
                        name="refund_prov_pic_list"
                        rules={[{ required: true, message: '必须上传图片，并且每张图不能大于300KB!' }]}
                    >
                        <Upload
                            name="files"
                            data={{ fileType: 1, bucketType: 4 }}
                            action={apiPrefix + '/global/upload_pic'}
                            listType="picture-card"
                            onChange={handleChange}
                            beforeUpload={file => {
                                setLoading(true)

                                const isLt = file.size < 300000;
                                if (!isLt) {
                                    message.error('每张图不能大于300KB!')

                                    setLoading(false)
                                    return false

                                } else {
                                    return true
                                }
                            }}
                        >
                            {fileList.length >= 6 ? null : uploadButton}
                        </Upload>
                    </Form.Item>

                    <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                        <Space>
                            <Button type="primary" htmlType="submit">确定</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    </div>
}